import {
  IonHeader,
  IonToolbar,
  isPlatform,
  IonPage,
  IonContent,
} from "@ionic/react";
import { Link } from "react-router-dom";
// Reac int
import { FormattedMessage } from "react-intl";

// Types
import { User, Settings } from "../../interfaces";

// Components
import Onboarding from "./onboarding";
import Stats from "./stats";
import { PlanUsageNavbar } from "../../components/usage/plan";

// Styles
import headerStyles from "../../theme/header.module.css";
import styles from "./styles.module.css";

// Api
import AiApi from "../../api/ai";
import { useAppStore } from "../../store/app";

// Other
const isMobile = isPlatform("android") || isPlatform("ios");

interface HeaderProps {
  name: string;
}

const Header: React.FC<HeaderProps> = ({ name }) => {
  return (
    <div>
      <h1 className={headerStyles.pageTitle}>
        <FormattedMessage id="home.pageTitle" /> {name} 👋
      </h1>
      <h3 className={headerStyles.pageDescription}>
        <FormattedMessage id="home.pageDescription" />
      </h3>
    </div>
  );
};

const MobileHeader: React.FC<HeaderProps> = ({ name }) => {
  return (
    <div>
      <div className={headerStyles.header}>
        <h1 className={headerStyles.mobileTitle}>
          <FormattedMessage id="home.pageTitle" /> {name} 👋
        </h1>
        <h3 className={headerStyles.mobileDescription}>
          <FormattedMessage id="home.pageDescription" />
        </h3>
      </div>
    </div>
  );
};

const MobileTitle = ({ settings }: { settings: Settings }) => {
  return (
    <IonHeader>
      <IonToolbar>
        <span className="ion-right-title">
          <FormattedMessage id="nav.home" />
        </span>
        <div slot="end" className="nav-usage">
          <Link to="/settings/payment" style={{ textDecoration: "none" }}>
            <PlanUsageNavbar settings={settings} isMobile={true} />
          </Link>
        </div>
      </IonToolbar>
    </IonHeader>
  );
};

const Home = () => {
  const user = useAppStore((state) => state.user);
  const settings = useAppStore((state) => state.settings);
  const setOnboarded = useAppStore((state) => state.setOnboarded);

  // API This is done now in the ai/onboarding/index.tsx
  const handleSkip = async () => {
    const { data } = await AiApi.putAiSettingsByField("onboarded", true);
    if (data) {
      setOnboarded(true);
    }
  };

  return (
    <IonPage id="main-content">
      {isMobile && <MobileTitle settings={settings} />}
      <IonContent
        {...(isMobile
          ? { fullscreen: true, color: "light", className: "ion-padding" }
          : {})}
      >
        <div className={isMobile ? "view-wrapper" : "page-wrapper container"}>
          {isMobile ? (
            <>
              <div className="view-pane">
                <MobileHeader name={user.email} />
              </div>

              <Onboarding
                settings={settings}
                isMobile={isMobile}
                //onSkip={handleSkip}
              />

              <Stats isMobile={isMobile} settings={settings} />
            </>
          ) : (
            <>
              <Header name={user.email} />

              <Onboarding
                settings={settings}
                isMobile={isMobile}
                //onSkip={handleSkip}
              />

              <div className={styles.stats}>
                <Stats isMobile={isMobile} settings={settings} />
              </div>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  user: User;
  settings: Settings;
}

export default Home;
